import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionDocumentProfiles extends Layout {
    ntbDocpId: Textbox;
    sourceImapCats: DataSource;
    sourceImgApps: DataSource;
    sourceRenditionDocProf: DataSource;
    sourceRenditionDocumentProfiles: DataSource;
    tbDocpAppid: Textbox;
    tbDocpCatid: Textbox;
    tbDocpId: Textbox;
    tbDocpSeq: Textbox;
    textboxDocpAppid: Textbox;
    textboxDocpCatid: Textbox;
    textboxDocpId: Textbox;
    textboxDocpSeq: Textbox;
    textboxIcatAppid: Textbox;
    textboxIcatCatdesc: Textbox;
    textboxIcatCatid: Textbox;
    textboxImapAppid: Textbox;
    textboxImapAppname: Textbox;
}
